import {eatClubClient} from "@globals/config/apiClient";

export function expireOrder(orderId: number): void {
  eatClubClient.put(`/api/v3/expire-order/${orderId}/`);
}

export function submitSurvey(
  surveyOption: number,
  feedbackText: string
): Promise<void> {
  return eatClubClient
    .put("/menusurvey/result/", {
      choice: surveyOption,
      extra_text: feedbackText,
    })
    .then((response) => response.data)
    .catch(({response}) => {
      const error = {
        status: response.status,
        message: response.data?.reason,
      };
      throw error;
    });
}
